import axios from 'axios';
import { checkIsInternal } from './createStorage';
import { config } from '@uhg-abyss/web/tools/config';
import { setupErrorInterceptor } from './error.interceptor';
import { setupTokenInterceptor } from './token.interceptor';
//const InternalApIUrls = ['https://uhcinsights-devext.uhc.com/'];
const fetchClient = () => {
  let abortController = typeof AbortController !== 'undefined' ? new AbortController() : null;

  const abortPendingRequests = () => {
    if (!abortController) {
      return;
    }
    abortController.abort();
    abortController = new AbortController();
  };

  let apiDomain;
  if(checkIsInternal()){
    apiDomain = config('API_GC_DOMAIN_INTERNAL');
  }
  else{
    apiDomain = config('API_GC_DOMAIN');
  }

  const defaultOptions = {
    baseURL: apiDomain,
    method: 'get',
    headers: {
      'Content-Type': 'application/json',
      'usertype': checkIsInternal() ? 'Internal' : 'External',
    },
  };


  // Create instance
  const instance = axios.create(defaultOptions);

  setupTokenInterceptor(instance, {
    apiDomain,
    getAbortSignal: () => (abortController ? abortController.signal : null),
  });

  setupErrorInterceptor(instance, abortPendingRequests);

  return instance;
};

export default fetchClient;
